import { AxiosError, AxiosResponse } from 'axios';

import { transformIncomingData } from './dataTransform';

export interface SuccessResponse<T = unknown> {
  data: T;
  type: 'success';
}
export interface IncomingError {
  errors: string[];
  conflictType?: string;
}

export interface ErrorResponse<K = unknown> {
  errors: K[];
  type: 'error';
  data?: K;
  status?: number;
}
type DataWithinData<T> = { data: { data: T } };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApiResponse<T = any, K = any> = SuccessResponse<T> | ErrorResponse<K>;

export const transformSuccess = <T>(response: AxiosResponse<T> & DataWithinData<T>): T => {
  const { data } = response;

  if (data?.data) {
    const { data: innerData } = data;

    // there could be additional data keys such as "meta" in the response
    return { ...data, data: innerData };
  }

  return data;
};

export const transformError = <T>({ response, message }: AxiosError): IncomingError | T => {
  if (message === 'canceled') {
    return { errors: ['Canceled request'] };
  }
  if (response?.status === 401) {
  } else if (response?.status === 500) {
    return { errors: ['Internal Server Error! Please try again later'] };
  }

  return (transformIncomingData(response?.data) as IncomingError) || { errors: [] };
};
